//////////////////////////////////////////////////////////////////////
//
// ライブラリのインポート
//
//////////////////////////////////////////////////////////////////////

// jQueryの"$"を使えるようにする
var $ = require('jquery');
window.$ = window.jQuery = require('jquery');

// TweenMax
var TweenMax = require('gsap');

// gsapのScrollToプラグイン（要imports-loader）
require('imports-loader?define=>false!gsap/ScrollToPlugin');

// ScrollMagic
var ScrollMagic = require('scrollmagic');

// vegas
var vegas = require('vegas');

// ScrollMagicのgsapプラグイン（要imports-loader）
require('imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap');

// jQuery easing
require('jquery.easing');

// jquery.mb.ytplayer
// var YTPlayer = require('jquery.mb.ytplayer')

//////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////

// PCの時にbodyに.hoverを付ける
var hover = require('./hover');

// ページトップへ戻る
var pagetop = require('./pagetop');
pagetop('#js-pagetop');

// SP幅のナビの処理
var spNavi = require('./sp-navi');

// front.jsを読み込み
var front = require('./front');

// def.jsを読み込み
var def = require('./def');



$(function () {
  animationScroll();
});

function animationScroll() {

  controller = new ScrollMagic.Controller();

  /////////////////////////////////////////////
  //
  // js-inViewクラスにis-showを付与する
  // アニメーション例：js-inView-fadeInUp等。
  // 詳細は"component/_in-view.scss"を参照。
  //
  /////////////////////////////////////////////
  $('.js-inView').each(function () {
    var currentStrong = this;

    var sceneEach = new ScrollMagic.Scene({
        triggerElement: currentStrong,
        reverse: false,
        offset: -200
      })
      .setClassToggle(currentStrong, 'is-show')
      .addTo(controller)
    // .addIndicators();
  });

}

$.ajax({
  type: 'get',
  url: '/image/sprite.svg'
}).done(function(data) {
  var svg = $(data).find('svg');
  $('body').prepend(svg);
});





//////////////////
// WEBPACK FOOTER
// ./src/js/main.js
// module id = 1
// module chunks = 0